import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentSections, SupplierInvoiceItemMapping } from 'shared';

type FormShape = { amount: FormControl<number | null> };

export class MappingFormsManager {
  private forms = new Map<string, FormGroup<FormShape>>();

  get(id: string) {
    return this.forms.get(id);
  }

  getAll() {
    return this.forms;
  }

  /** Create or refresh a single form based on a mapping + max amount + lock state */
  upsert(mapping: SupplierInvoiceItemMapping, maxAllowed: number, locked: boolean) {
    const id = mapping['@id']!;
    let form = this.forms.get(id);
    if (!form) {
      form = new FormGroup<FormShape>({
        amount: new FormControl(mapping.amount as number, {
          validators: [Validators.required, Validators.min(1), Validators.max(maxAllowed)],
          nonNullable: false,
        }),
      });
      this.forms.set(id, form);
    } else {
      const ctrl = form.controls.amount;
      if (ctrl.value !== mapping.amount) ctrl.setValue(mapping.amount as number, { emitEvent: false });
      ctrl.setValidators([Validators.required, Validators.min(1), Validators.max(maxAllowed)]);
      ctrl.updateValueAndValidity({ emitEvent: false });
    }

    if (locked) form.disable({ emitEvent: false });
    else form.enable({ emitEvent: false });
  }

  /** Sync all forms from DocumentSections and prune removed */
  syncFromSections(
    sections: DocumentSections<SupplierInvoiceItemMapping> | null | undefined,
    getMaxAllowedAmount: (m: SupplierInvoiceItemMapping) => number,
    locked: boolean,
  ) {
    const seen = new Set<string>();
    for (const arr of Object.values(sections ?? {})) {
      for (const m of arr as SupplierInvoiceItemMapping[] ?? []) {
        if (!m?.['@id']) continue;
        seen.add(m['@id']!);
        this.upsert(m, getMaxAllowedAmount(m), locked);
      }
    }
    // prune
    for (const id of Array.from(this.forms.keys())) {
      if (!seen.has(id)) this.forms.delete(id);
    }
  }

  setLocked(locked: boolean) {
    for (const [, form] of this.forms) {
      if (locked) form.disable({ emitEvent: false });
      else form.enable({ emitEvent: false });
    }
  }
}
